import type { Buyer } from "@getbread/api-client-buyer-v2";

export const buyerId = "cb9b98bd-ed93-4124-bf72-7fce6d22fd61";

export const buyer: Record<string, Buyer> = {
	[buyerId]: {
		id: buyerId,
		tenantID: "e9b6dddf-3fdc-4f0e-9dd3-8c82b529eb70",
		identity: {
			birthDate: new Date("1980-07-13T00:00:00.000Z"),
			name: {
				additionalName: "Q",
				familyName: "Smith",
				givenName: "Jane",
			},
			email: "user@example.com",
			emailVerified: true,
			phone: "+15555551234",
			phoneVerified: true,
		},
		primaryContactID: "3db2f95b-fed6-44dc-b512-d19a9d8a869b",
		contacts: {
			"3db2f95b-fed6-44dc-b512-d19a9d8a869b": {
				id: "3db2f95b-fed6-44dc-b512-d19a9d8a869b",
				buyerID: "cb9b98bd-ed93-4124-bf72-7fce6d22fd61",
				address: {
					address1: "123 First Street",
					address2: "Apt 1",
					locality: "New York City",
					region: "New York",
					postalCode: "10000",
					country: "US",
				},
				name: {
					additionalName: "Q.",
					familyName: "Smith",
					givenName: "Jane",
				},
				email: "user@example.com",
				phone: "+15555551234",
				createdAt: new Date("2020-08-04T17:40:29.172833Z"),
				updatedAt: new Date("2020-08-04T17:40:29.172833Z"),
			},
		},
		languagePreference: "en-us",
		status: "ACTIVE",
		subStatus: "ACTIVE",
		createdAt: new Date("2020-08-04T17:40:29.172833Z"),
		updatedAt: new Date("2020-08-04T17:40:29.172833Z"),
	},
};
